import type { LabelColor } from '~components/ui/label'

export const getMatchRateColor: (matchRate: number) => LabelColor = matchRate => {
  if (matchRate >= 70) {
    return 'primary'
  }
  if (matchRate >= 10) {
    return 'down-pour'
  }
  return 'architecture-blue'
}
